import { render, staticRenderFns } from "./ShopTournamentRanking.vue?vue&type=template&id=248e1e4a"
import script from "./ShopTournamentRanking.vue?vue&type=script&lang=js"
export * from "./ShopTournamentRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports